<template>
  <PageWrap page-title="Códigos postales">
    <!--Filtros -->
    <b-row>
      <b-col cols="4">
        <BfInput
          v-model="searchTermCodigoPostal"
          data-key="key"
          label="Código postal"
          placeholder="Buscar por código postal"
          @update="updateSearch"
          :clereable="true"
          :left-border="false"
        />
      </b-col>
      <b-col cols="4">
        <BfInput
          v-model="searchTermMunicipio"
          data-key="key"
          label="Municipio"
          placeholder="Buscar por municipio"
          @update="updateSearch"
          :left-border="false"
        />
      </b-col>
      <b-col cols="4">
        <BfSelect
          label="Zonas"
          data-key="zonas_id"
          :options="zonasParaSelector"
          :value="valueSelectorZonas"
          v-model="valueSelectorZonas"
          @update="updateSearch"
          :clearable="true"
        />
      </b-col>
    </b-row>

    <LoadingIndicator v-if="loadingData" />

    <BfTable
      v-else
      :data="data"
      :columns="tableColumns"
      border
      @row-click="tableRowClick"
      cell-class-name="tasaciones-small-cell"
      @sort-change="sortTable"
    >
      <span slot="nombre" slot-scope="{ row }" class="tasaciones-table-marker">
        {{ row.nombre }}
      </span>
    </BfTable>

    <b-row class="mt-5">
      <b-col>
        <BfButton :to="{ name: 'codigopostal' }" tag="router-link">
          Nuevo código postal
        </BfButton>
      </b-col>
      <b-col class="text-right">
        <BfPagination
          v-if="data.length"
          :current-page="currentPage"
          :total="totalRows"
          :page-size="perPage"
          @current-change="updatePagination"
        />
      </b-col>
    </b-row>
  </PageWrap>
</template>

<script>
/* eslint-disable object-curly-newline */
import PageWrap from '@/components/PageWrap'
import LoadingIndicator from '@/components/LoadingIndicator'
import router from '@/router'
import { codigosPostalesApi } from '@/api'
import { debounce, get, moment } from '@/utils'

export default {
  name: 'codigosPostales',
  data() {
    return {
      delegations: [],
      currentPage: 1,
      dateFrom: '',
      dateTo: '',
      loadingData: false,
      perPage: 50,
      searchTerm: '',
      searchTermCodigoPostal: '',
      searchTermMunicipio: '',
      totalRows: 0,
      zonasParaSelector: undefined,
      valueSelectorZonas: '',
      tableSort: '',
      showModal: false,

      //

      data: [],
    }
  },

  created() {
    this.loadData()
  },

  methods: {
    async fetchData() {
      const { key = null, order } = this.tableSort

      const {
        data: { data, current_page: currentPage, per_page: perPage, total },
        zonas,
      } = await codigosPostalesApi.getAll({
        codigopostal: this.searchTermCodigoPostal,
        zonas: this.valueSelectorZonas,
        municipio: this.searchTermMunicipio,
        page: this.currentPage,
        perPage: this.perPage,
        search: this.searchTerm,
        to: this.dateTo !== '' ? this.dateTo : undefined,
        sort: key ? `${order === 'descending' ? '-' : ''}${key}` : '',
      })

      this.data = data
      this.totalRows = total
      this.perPage = Number(perPage)
      this.currentPage = currentPage

      this.zonasParaSelector = zonas.map(({ nombre, id }) => ({
        label: nombre,
        value: id,
      }))
    },
    async loadData() {
      this.loadingData = true
      this.fetchData()
      this.loadingData = false
    },

    // eslint-disable-next-line func-names
    updateSearch: debounce(function () {
      if (!this.loadingData) {
        this.loadData()
      }
    }, 350), // original 350

    tableRowClick({ row, column }) {
      const { id } = row
      // alert(id)
      router.push({ name: 'codigopostal', params: { id: `${id}` } })
    },

    updatePagination(newPage) {
      if (newPage !== this.currentPage) {
        this.currentPage = newPage

        this.fetchData()
      }
    },
    sortTable(data) {
      this.tableSort = data
      // Ajusts de alias de columnas
      if (data.key === 'zona_nombre') {
        this.tableSort.key = 'zonas_id'
      }
      this.fetchData()
    },
  },

  computed: {
    tableColumns() {
      return [
        {
          label: 'CP',
          dataKey: 'codigopostal',
          sortable: 'custom',
          isPrimary: true,
          //  width: 200,
        },
        {
          label: 'Población',
          dataKey: 'poblacion',
          sortable: 'custom',
          //  width: 400,
        },
        {
          label: 'Municipio',
          dataKey: 'municipio',
          sortable: 'custom',
        },
        {
          label: 'Provincia',
          dataKey: 'provincia',
          sortable: 'custom',
        },
        {
          label: 'Zona',
          dataKey: 'zona_nombre',
          sortable: 'custom',
        },
      ]
    },
  },

  components: {
    LoadingIndicator,
    PageWrap,
  },
}
</script>
